module.exports = __webpack_public_path__ + "d9cefee260f6dd328459a57a157bba3a.jpg";